module.exports = __webpack_public_path__ + "img/logo.7615f5a0.png";